module.exports = __webpack_public_path__ + "static/media/HomeBanner.1c6ba8f4.png";